export default "__VITE_ASSET__DSv79hHU__";